<template>
  <div>
    <tax-form-control-one v-if="personCount===1" :component-data="componentProps"></tax-form-control-one>
    <tax-form-control-two v-if="personCount===2" :component-data="componentProps"></tax-form-control-two>
  </div>
</template>

<script>
import TaxFormControlOne from "./TaxFormControlOne";
import TaxFormControlTwo from "./TaxFormControlTwo";

export default {
  name: "TaxFormWrapper",
  components: {
    TaxFormControlOne,
    TaxFormControlTwo
  },
  props: {
    personCount: '',
    flowData: '',
    oldData: '',
    errorState: ''
  },
  data() {
    return {
      componentType: 'TaxFormControlOne',
      componentProps: {
        personCount: this.personCount,
        flowData: this.flowData,
        oldData: this.oldData,
        errorState: this.errorState
      }
    }
  },
  computed: {
    componentSelect() {
      if(this.personCount === 1) {
        this.componentType = 'TaxFormControlOne'
      }
      if(this.personCount === 2) {
        this.componentType = 'TaxFormControlTwo'
      }
    }
  }
}
</script>